<form [formGroup]="form">
  <div
    class="form-control form-control-solid form-control-datepicker"
    [class.disabled]="isDisabled"
  >
    <mat-form-field appearance="outline" class="date-range">
      <input
        [placeholder]="placeholder"
        [matDatepicker]="picker"
        [min]="minDate"
        [max]="maxDate"
        [formControlName]="ControlName"
        (dateChange)="onDateChange($event)"
        (click)="picker.open()"
        matInput
        readonly
      />
      <mat-datepicker-toggle [for]="picker" class="ms-auto" matIconSuffix>
        <mat-icon matDatepickerToggleIcon>
          <span
            [inlineSVG]="STRING_CONSTANTS.ICON.IC_CALENDAR"
            [style.opacity]="isDisabled ? '0.5' : '1'"
            class="svg-icon svg-icon-2"
          ></span>
        </mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker [disabled]="isDisabled" />
    </mat-form-field>
  </div>
</form>
